// extracted by mini-css-extract-plugin
export default {"root":"LoaderCard_root__sfhNR","root_toast":"LoaderCard_root_toast__f3U3G"};